var map = {
	"./BUILDING.png": 8691,
	"./DISCUSSION.png": 4700,
	"./HOVER.png": 6456,
	"./NEW.png": 7948,
	"./PILOT.png": 1116,
	"./PLAYGROUND.png": 7979,
	"./Rectangle.png": 9989,
	"./Rectangle_bottom.png": 4283
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7099;